import SmoothScroll from 'smooth-scroll/dist/smooth-scroll';
import 'smooth-scroll/dist/smooth-scroll.polyfills';

export default {
    name: 'topic-preview',
    components: {},
    props: [],
    data() {
        return {
            questionnaire: null,
            topic: null,
            prevTopic: null,
            nextTopic: null,
            stickyMenu: false,
            filterTypes: {
                'All': 1,
                'Incomplete': 2
            },
            currentFilter: 1,

            toggleDetails: false,

            feedbackModal: false,
            feedbackText: ''
        }
    },

    watch: {
        '$route' (to, from) {
            if (from.params.id !== to.params.id) {
                this._loadPageData();
            }
        },

        'feedbackModal'(newValue) {
            if (newValue) {
                this.feedbackText = '';
                this.$refs.feedbackForm.reset();
            }
        }
    },

    computed: {
        assessmentIsSubmitted() {
            return this.questionnaire && this.questionnaire.isSubmitted;
        },

        topicIsNotStarted() {
            return this.topic && this.topic.questions.filter((question) => {
                if (question.visible) {
                    return question;
                }
            }).length == this.topic.questions.filter((question) => {
                if (!question.defAnswerId) {
                    return question;
                }
            }).length;
        },

        topicIsInProgress() {
            return this.topic && this.topic.questions.filter((question) => {
                if (question.visible) {
                    return question;
                }
            }).length > this.topic.questions.filter((question) => {
                if (question.defAnswerId) {
                    return question;
                }
            }).length;
        },

        topicIsCompleted() {
            if (this.saveInProgress) {
                return false;
            } else {
                return this.topic && this.topic.questions.filter((question) => {
                    if (question.visible) {
                        return question;
                    }
                }).length == this.topic.questions.filter((question) => {
                    if (question.defAnswerId) {
                        return question;
                    }
                }).length;
            }
        },

        topicScore() {
            return this.topic.scoreDefinition ? (this.topic.scoreDefinition.score || 0) : 0;
        },

        topicScoreLabel() {
            return this.topic.scoreDefinition ? (this.topic.scoreDefinition.label || 'N/A') : 'N/A';
        },

        topicScoreColor() {
            return this.topic.scoreDefinition ? (this.topic.scoreDefinition.color || '#000000') : '#000000';
        },

        topicProgress() {
            return this.topic ? (this.topic.progress || 0) : 0;
        },

        allQuestionsCount() {
            return this.topic ? this.topic.questions.filter((question) => {
                if (question.visible) {
                    return question;
                }
            }).length : 0;
        },

        incompleteQuestionsCount() {
            return this.topic ? this.topic.questions.filter((question) => {
                if (!question.defAnswerId && question.visible) {
                    return question;
                }
            }).length : 0;
        },

        saveInProgress() {
            return this.topic ? this.topic.questions.filter((question) => {
                if (question.isSaving) {
                    return question;
                }
            }).length > 0 : false;
        }
    },

    created() {
        this._handleScrolling = this._handleScrolling.bind(this);
        this.smoothScroll = new SmoothScroll('a[href*="#"]');
    },

    mounted() {
        this.$state.set('loading', true);
        this._loadTopicData();
        document.addEventListener('scroll', this._handleScrolling);
    },

    beforeDestroy() {
        document.removeEventListener('scroll', this._handleScrolling);
    },

    methods: {
        _handleScrolling() {
            if (window.scrollY > 175) {
                this.stickyMenu = true;
            } else {
                this.stickyMenu = false;
            }
        },

        async _loadPageData() {
            this.$state.set('loading', true);
            this._loadTopicData();
            this.smoothScroll.animateScroll(0);
            this.currentFilter = this.filterTypes.All;
        },

        async _loadTopicData() {
            let self = this;

            await this.$authManager.getUser(function (user) {
                self.$api.getTopic(self.$route.params.id, user).then(function (result) {
                    //self.questionnaire = null;
                    //self.topic = null;
                    //self.prevTopic = null;
                    //self.nextTopic = null;
                    //self._sycAssessmentData();

                    //self.$nextTick(function () {
                        self.questionnaire = result.questionnaire;
                        self.topic = self._buildTopicResult(result.currentTopic);
                        self.prevTopic = self._buildTopicResult(result.previousTopic);
                        self.nextTopic = self._buildTopicResult(result.nextTopic);

                        self._sycAssessmentData();
                    //});
                });
            });
        },

        async _submitAnswer(question) {
            let self = this;

            question.isSaving = true;
            await this.$authManager.userIsAuthenticated(function (user) {
                self.$nextTick(() => {
                    self.$api.submitAnswer(question, user, function (response) {
                        if (response && response.status == 200) {
                            let result = response.data;

                            self.questionnaire = result.questionnaire;
                            self.topic = self._buildTopicResult(result.currentTopic);
                            //self.prevTopic = self._buildTopicResult(result.previousTopic);
                            //self.nextTopic = self._buildTopicResult(result.nextTopic);

                            self._sycAssessmentData();

                            question.isSaving = false;
                        }
                    });
                });
            });
        },

        async _sendFeedback() {
            let self = this;

            if (!self.$refs.feedbackForm.validate())
                return;

            self.$state.set('loading', true);
            await self.$authManager.userIsAuthenticated(function (user) {
                self.$nextTick(() => {
                    self.$api.sendFeedback(self.topic.id, self.feedbackText, user, function (response) {
                        if (response && response.status == 200) {
                            self.feedbackModal = false;
                        }
                        self.$state.set('loading', false);
                    });
                });
            });
        },

        async _sync() {
            this.$api.postTopic(this.topic);
        },

        async _sycAssessmentData() {
            let self = this;

            this.$state.set('loading', false);
            self.$state.set('questionnaire', self.questionnaire || {});
            self.$state.set('topics', self.questionnaire ? self.questionnaire.topics : []);
        },

        _buildTopicResult(topic) {
            if (topic) {
                topic.questions.forEach(function (question) {
                    Object.assign(question, { isSaving: false });
                });
            }

            return topic;
        },

        changeTopic(path) {
            this.$router.push(path);
        },

        async _filterQuestions(filterType) {
            this.currentFilter = filterType;
        },

        _getFilteredQuestions() {
            if (this.currentFilter == this.filterTypes.Incomplete) {
                return this.topic.questions.filter((question) => {
                    if (!question.defAnswerId) {
                        return question;
                    }
                });
            } else {
                return this.topic.questions;
            }
        }
    }
}
